import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function ProblemSection() {
  const {
    t
  } = useLanguage();
  const painPoints = [t('problem.pain1'), t('problem.pain2'), t('problem.pain3'), t('problem.pain4')];
  return <section className="bg-brand-alt py-16 md:py-24" data-id="element-137">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-138">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-139">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-6" data-id="element-140">
            {t('problem.title')}
          </h2>
          <p className="text-lg text-brand-text leading-relaxed" data-id="element-141">
            {t('problem.body1')}
          </p>
          <p className="text-lg text-brand-text font-semibold mt-4" data-id="element-142">
            {t('problem.body2')}
          </p>
        </motion.div>

        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-10 mb-10" data-id="element-143">
          <ul className="space-y-6" data-id="element-144">
            {painPoints.map((point, index) => <motion.li key={index} className="flex items-start space-x-4" initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} data-id="element-145">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-146" />
                <span className="text-lg text-brand-text font-medium" data-id="element-147">
                  {point}
                </span>
              </motion.li>)}
          </ul>
        </div>

        <motion.div className="text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} data-id="element-148">
          <p className="text-xl md:text-2xl font-bold text-brand-primary" data-id="element-149">
            {t('problem.closing')}
          </p>
        </motion.div>
      </div>
    </section>;
}